import { useState, useEffect } from 'react'
import Breadcrumb from '../../components/breadcrumb/index'
import DataTable_Component from '../../components/DataTable/index'
import Btn_grp from '../../components/payment/payment_btn_grp/index'
import Details_modal from '../../components/payment/details_modal/index'

import { apidata } from './store/store'
import { btn_link } from "./btn_link/btn_link";


export default function TrashPayment() {

    const title="Trash payments"
    const [rerendarApi, setRerendarApi] = useState('')
    {/* all data for view */ }
    const [selectVal_details, setSelectVal_details] = useState([])
    {/* see all details modal(view) */ }
    const [details_modal_show, set_details_modal_Show] = useState(false);
    const [view_id, setViewId] = useState();
    const [columnState, setcolumns] = useState([])
    const [data, setData] = useState(apidata)


    const trash_data = data.filter((val) => {
        return val.status == "trash"
    })

    // show view modal;
    const handleShow_view_modal = (row) => {
        setViewId(row.id)
        setSelectVal_details(row)
        set_details_modal_Show(details_modal_show => !details_modal_show);
    }
    // end view modal config

    useEffect(() => {
        // call api and response data set " setApiData(your res.data) " and column setcolumns( columns )
        setData(apidata)
        setcolumns(columns)
        console.log("render from trash")
    }, [rerendarApi])


    const rerender = (e) => {
        setRerendarApi(e)
    }

    const brad = [
        {
            name: "home",
        },
        {
            name: "Trash-payments",
        }
    ]

    const columns = [
        {
            name: "Brand",
            selector: row => row.brand,
            sortable: true
        },
        {
            name: "Full Name",
            selector: row => row.name,
            sortable: true
        },
        {
            name: "Payment Method",
            selector: row => row.payment_method,
            sortable: true
        },
        {
            name: "Amount",
            selector: row => row.amount,
            sortable: true
        },
        {
            name: "Charged Amount",
            selector: row => row.amount,
            sortable: true
        },
        
        {
            name: "Date",
            selector: row => row.date,
            sortable: true
        },

        {
            name: "action",
            cell: (row) => <><button className=" btn btn-primary" onClick={() => handleShow_view_modal(row)} >view</button></>,
        }

    ]
    return (
        <>
            <Details_modal rerendar={(e) => rerender(e)} view_id={view_id} row={selectVal_details} openDetailsModal={details_modal_show} />

            <div className="container-fluid">
                <Breadcrumb title={title} brad={brad} />
                <Btn_grp active_btn="trash" btn_link={btn_link} />
                <div className="row my-3">
                    <div className="col-12">
                        <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
                            <div className="card-header d-flex justify-content-between border-bottom pb-1">
                                 <h4>{title}</h4>                            
                            </div>
                            <div className="card-body">                               
                                <DataTable_Component  search="name" title={title} apidata={trash_data} columns={columnState} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}